import React from 'react';
import { format } from 'date-fns';
import { Locale } from 'date-fns/locale';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { isNavigationDisabled } from './utils';

interface CalendarHeaderProps {
    currentMonth: Date;
    minDate: Date;
    maxDate: Date;
    prevMonth: () => void;
    nextMonth: () => void;
    locale: Locale;
}

const CalendarHeader: React.FC<CalendarHeaderProps> = ({
    currentMonth,
    minDate,
    maxDate,
    prevMonth,
    nextMonth,
    locale
}) => {
    const { isPrevDisabled, isNextDisabled } = isNavigationDisabled(currentMonth, minDate, maxDate);

    return (
        <div className="flex justify-between items-center mb-4 px-1">
            <button
                onClick={prevMonth}
                disabled={isPrevDisabled}
                className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 dark:focus:ring-blue-400 dark:focus:ring-opacity-40 transition-colors duration-150"
                aria-label="Previous month"
            >
                <ChevronLeft className="h-5 w-5 text-gray-600 dark:text-gray-400" />
            </button>
            <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
                {format(currentMonth, 'MMMM yyyy', { locale })}
            </h2>
            <button
                onClick={nextMonth}
                disabled={isNextDisabled}
                className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 dark:focus:ring-blue-400 dark:focus:ring-opacity-40 transition-colors duration-150"
                aria-label="Next month"
            >
                <ChevronRight className="h-5 w-5 text-gray-600 dark:text-gray-400" />
            </button>
        </div>
    );
};

export default React.memo(CalendarHeader);